import { gql } from "@apollo/client";

export default gql`
  query platformSkills($organizationId: Int) {
    platformSkills(organizationId: $organizationId) {
      id
      name
      slug
      description
      visibility
      canEdit
      canArchive
    }
  }
`;
